import * as React from 'react';
import { IBaseTimelineElement } from "./TimelineSegment";
import { css } from "office-ui-fabric-react";

export type SegmentCoordinates = {
    left: number;
    width: number;
    isOutOfScale: boolean;
    trimmedStart?: boolean;
    trimmedEnd?: boolean;
}
export const TimelineBaseSegment = ({coordinates, data, className}: {coordinates: SegmentCoordinates, data: IBaseTimelineElement, className: string}) => {
    if (coordinates.isOutOfScale) {
        return null;
    }
    return <div 
        className={css("timeline segment", className, data.className, coordinates.trimmedStart && 'trim-left', coordinates.trimmedEnd && 'trim-right')} 
        style={{ ...data.style, left: coordinates.left, width: coordinates.width }}>
    </div>;
}